import React from "react";
import { Navigate, Outlet } from "react-router";
import { ROUTES_CONSTANTS } from "../constants";
import { getFromStorage } from "../utils";
import { useAuth } from "../context";
import { Loader, HeaderIcons } from "../components";
import { ProfileImage } from "../assets";

const UserLayout = () => {
  const token = getFromStorage("accessToken");
  const { currentUser, isLoading } = useAuth();

  if (!token) {
    return <Navigate to={ROUTES_CONSTANTS.LOGIN} replace />;
  }

  if (isLoading || !currentUser) {
    return <Loader />;
  }

  if (currentUser.role_id === 0) {
    return <Navigate to={ROUTES_CONSTANTS.COMPANY_MANAGEMENT} replace />;
  }

  if (currentUser.role_id === 1) {
    return <Navigate to={ROUTES_CONSTANTS.COMPANY_DASHBOARD} replace />;
  }

  return (
    <div className="p-8 min-h-screen">
      <HeaderIcons
        userImage={ProfileImage}
        userName={currentUser.full_name || currentUser.name || "User"}
      />
      <Outlet />
    </div>
  );
};

export default UserLayout;
